import classNames from 'classnames';
import { forwardRef, HTMLProps } from 'react';

export const StepBody = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={classNames(className, 'flex-grow-1 overflow-auto')}
        ref={ref}
        {...props}
      />
    );
  }
);

export const StepFooter: React.FC<HTMLProps<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div className={classNames('d-flex justify-content-end pt-1')} {...props} />
  );
};
